import User from "./user";

export interface EmailGroupItem {
  id?: number;
  companyId?: number;
  parentId?: number;
  type?: string;
  userId?: number;
  user?: User;
  email?: string;
  groupId?: number;
  emailGroup?: EmailGroup;
}

interface EmailGroup {
  id?: number;
  companyId?: number;
  name?: string;
  active?: boolean;
  items?: EmailGroupItem[];
}

export const newEmailGroup = (): EmailGroup => {
  return {};
};

export const newEmailGroupItem = (): EmailGroupItem => {
  return {};
};

export default EmailGroup;
